<template>
  <PageLayout>
    <!-- Main Content -->
    <template #main>
      <h1>App Playground</h1>
      <p>This is the main content area of the App Playground.</p>
      ascsc scak nalks ncalskj dsalkdj aslkdjasj lsdlkasj dsascsc scak nalks ncalskj dsalkdj aslkdjasj lsdlkasj dsalkdj lkjdaslk djsalkdj salkdj salkdjsadl kjlkdj lkjdaslk djsalkdj salkdj salkdjsadl kjsadlksaj dlksajd lsakjd asldjsalk jdsadlkj asdlkj asdlkjsa lkjsad lkjasdl ksad lsakjd
    </template>

    <!-- Sidebar -->
    <template #sidebar>
      <PageSidebar title="Playground" :show-divider="true">
        <!-- Sidebar Header (optional - überschreibt default title) -->
        <template #header>
          <h2 class="custom-title">Custom Playground Title</h2>
        </template>

        <!-- Sidebar Body -->
        <template #body>
          <div class="overview-section">
            <p>Sidebar content goes here.</p>

            <div class="step-item">
              <div class="step-header">
                <span class="step-title">Step 1</span>
              </div>
              <div class="step-divider"></div>
            </div>

            <div class="step-item active">
              <div class="step-header">
                <span class="step-title">Step 2</span>
              </div>
              <div class="step-divider"></div>
            </div>

            <p>and also here.</p>
          </div>
        </template>

        <!-- Sidebar Footer (optional) -->
        <template #footer>
          <button class="action-button">Complete Playground</button>
        </template>
      </PageSidebar>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';

export default {
  name: 'Overview',

  components: {
    PageLayout,
    PageSidebar
  },
}
</script>

<style lang="scss">
.container-fluid {
  padding-left: unset !important;
  padding-right: unset !important;
}
</style>

<style lang="scss" scoped>
.custom-title {
  font-size: 28px;
  font-weight: 400;
  color: #f50537;
}

.overview-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-item {
  padding-bottom: 12px;
  cursor: pointer;

  &.active {
    .step-title {
      color: #000000;
      font-weight: 600;
    }

    .step-divider {
      background-color: #000000;
    }
  }
}

.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  transition: all 0.2s;

  &:hover {
    .step-title:not(.active) {
      color: #374151;
    }
  }
}

.step-title {
  font-size: 16px;
  transition: all 0.2s;
  color: var(--color-muted-foreground);
  font-weight: normal;
}

.step-divider {
  height: 1px;
  width: 100%;
  background-color: #e5e7eb;
  transition: background-color 0.2s;
}

.action-button {
  width: 100%;
  padding: 12px 24px;
  background-color: #f50537;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #d42f3e;
  }
}
</style>
